<div fxLayout="column" class="u-height-100">
  <div fxFlex="100%" class="u-overflow-auto u-showScrollBar u-padding-24">
    <mat-slide-toggle
      labelPosition="before"
      [formControl]="selectableForUserIntroductionControl"
      class="u-marginBottom-8 u-width-100 mat-slide-toggle-label--before"
      i18n="@@hubConfigRolesSettings.selectableByUsersToggle"
    >
      Allow members to set their matching rules for this segment. When enabled,
      this option shows in onboarding and their Hub membership preferences.
    </mat-slide-toggle>
  </div>
  <div
    class="u-padding-8-0 u-padding-0-16 u-borderTop-grey100"
    fxFlex="0 0 auto"
    fxLayoutAlign="end center"
    fxLayoutGap="16px"
  >
    <button mat-button (click)="closeDrawer()" i18n="@@global.cancel">
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="submitForm()"
      [disabled]="!selectableForUserIntroductionControl.valid || isLoading"
    >
      <span i18n="@@global.save">Save</span>
      <i
        *ngIf="isLoading"
        nz-icon
        nzSpin
        nzType="sync"
        class="u-marginLeft-8"
      ></i>
    </button>
  </div>
</div>
